import { useState } from "@wordpress/element";
import { useEffect } from "@wordpress/element";

const FILTER_TITLES = {
  billCongressNumber: "Session",
  billCongressChamber: "Chamber",
  billSponsorFilterData: "Sponsor",
  billCosponsorsFilterData: "Cosponsors",
  billCommitteesFilterData: "Committees",
  billEvidenceProvisions: "Evidence Provisions",
  billIssueArea: "Issue Area",
};

export function Filters({ data, filters, setFilters, setPage }) {

  useEffect(() => {

    const dropdowns = document.querySelectorAll('.filter-list');

    function handleToggle(e) {
      if (!e.target.open) return;

      dropdowns.forEach(d => {
        if (d !== e.target) {
          d.removeAttribute('open');
        }
      });
    }

    function handleClickOutside(e) {
      const clickedInside = e.target.closest('.filter-list');
      if (!clickedInside) {
        dropdowns.forEach(d => d.removeAttribute('open'));
      }
    }

    dropdowns.forEach(d =>
      d.addEventListener('toggle', handleToggle)
    );

    document.addEventListener('click', handleClickOutside);

    return () => {
      dropdowns.forEach(d =>
        d.removeEventListener('toggle', handleToggle)
      );
      document.removeEventListener('click', handleClickOutside);
    };

  }, []);


  const facets = data?.facetDistribution || {};

  const hasActiveFilters = Object.values(filters).some(arr => arr.length > 0);

  function clearAllFilters() {
    setPage(1);
    setFilters({});
  }

  // Store search terms per facet key
  const [facetSearch, setFacetSearch] = useState({});

  function toggleFilter(key, value) {

    setPage(1);

    setFilters(prev => {

      const next = { ...prev };
      const current = next[key] || [];

      if (current.includes(value)) {
        next[key] = current.filter(v => v !== value);
        if (!next[key].length) delete next[key];
      } else {
        next[key] = [...current, value];
      }

      return next;
    });
  }

  const orderedFacets = Object.entries(FILTER_TITLES)
    .map(([key, title]) => {

      const values = facets[key];
      if (!values) return null;

      return {
        key,
        title,
        values: Object.entries(values)
          .sort((a, b) => b[1] - a[1])
      };

    })
    .filter(Boolean);

  return (
    <>

      {hasActiveFilters && (
        <div className="clear-all-wrapper">
          <button
            type="button"
            className="clear-all-filters"
            onClick={clearAllFilters}
          >
            Clear all
          </button>
        </div>
      )}
      
    {orderedFacets.map((facet) => {

      const searchTerm = facetSearch[facet.key] || "";
      const allValues = facet.values;

      const selectedValues = filters[facet.key] || [];

      const filteredValues = searchTerm
        ? allValues.filter(([label]) =>
            label.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : allValues;

      const mergedValues = [
        ...selectedValues
          .filter(sel =>
            !filteredValues.some(([label]) => label === sel)
          )
          .map(sel => {
            const original = allValues.find(([label]) => label === sel);
            return original || [sel, 0];
          }),
        ...filteredValues
      ];

      const showSearch = allValues.length > 10;

      return (
        <details
          key={facet.key}
          data-key={facet.key}
          className="filter-list"
        >
          <summary className="filter-summary">
            {facet.title}
            {selectedValues.length > 0 && (
              <span className="selected-count">
                ({selectedValues.length})
              </span>
            )}
          </summary>

          <div className="filter-panel">

            {showSearch && (
              <input
                type="text"
                className="facet-search"
                placeholder="Search filters..."
                value={searchTerm}
                onChange={(e) =>
                  setFacetSearch(prev => ({
                    ...prev,
                    [facet.key]: e.target.value
                  }))
                }
              />
            )}

            <div className="filter-options">

              {mergedValues.map(([label, count], valueIndex) => {

                const inputId = `${facet.key}-${valueIndex}`;

                return (
                  <div
                    key={label}
                    className="filter-line"
                    data-count={`(${count})`}
                  >
                    <input
                      type="checkbox"
                      id={inputId}
                      checked={filters[facet.key]?.includes(label) || false}
                      onChange={() => toggleFilter(facet.key, label)}
                    />

                    <label htmlFor={inputId}>
                      {label}
                    </label>
                  </div>
                );

              })}

            </div>

          </div>
        </details>
      );

    })}
    </>

  );
}
